import flatpickr from "flatpickr";
import { Czech } from "flatpickr/dist/l10n/cs.js"
import "flatpickr/dist/flatpickr.min.css";

export function initFlatpickrRangeDateTime(
    element: HTMLElement,
)
{
    flatpickr(element, {
        mode: 'range',
        enableTime: true,
        minDate: element.dataset.minDate,
        maxDate: element.dataset.maxDate,
        dateFormat: 'Y-m-d H:i',
        altInput: true,
        allowInput: true,
        altFormat: 'j.n.Y H:i',
        locale: Czech
    })
}

export function initFlatpickrRangeDate(
    element: HTMLElement,
)
{
    const minDate = element.dataset.editMode ? null : (element.dataset.minDate ?? null);
    const maxDate = element.dataset.editMode ? null : (element.dataset.maxDate ?? null);
    
    const fp = flatpickr(element, {
        mode: 'range',
        enableTime: false,
        minDate: minDate,
        maxDate: maxDate,
        dateFormat: 'Y-m-d',
        altInput: true,
        allowInput: true,
        altFormat: 'j.n.Y',
        locale: Czech,
    })
}